import styled from "styled-components";

import ll from "../../assets/img/l.png";
import rr from "../../assets/img/r.png";

export const ForumGuestsWrapper = styled.div`
    width: 1000px;
    margin: 0 auto;
    .carousel {
        background-color: #e3e3e3;
        padding: 15px 30px;
        position: relative;
        .ll {
            position: absolute;
            width: 22px;
            height: 58px;
            background: url(${ll}) 50% 50% / contain no-repeat;
            top: 50%;
            transform: translateY(-50%);
            left: 4px;
            cursor: pointer;
        }
        .rr {
            position: absolute;
            width: 22px;
            height: 58px;
            background: url(${rr}) 50% 50% / contain no-repeat;
            top: 50%;
            transform: translateY(-50%);
            right: 4px;
            cursor: pointer;
        }
        .imgBox {
            overflow: hidden;
            .img {
                float: left;
                width: 19.6%;
                margin-bottom: 10px;
                margin-left: 0.2%;
                margin-right: 0.2%;
            }
        }
    }
    .swiper {
        width: 100%;
        height: 100%;
    }
    .swiper-slide {
    }
    .swiper-slide img {
        display: block;
        width: 100%;
        margin-bottom: 10px;
    }

    @media screen and (max-width: 750px) {
        width: 100%;
    }
`;
